module.exports = __webpack_public_path__ + "img/7_affordableAndCleanEnergy.73ac8800.png";